import { NotificationType } from "../constants/notificationType.constant";
import {
  GetNotificationsResponse,
  Notification,
  NotificationsPayload,
} from "../interfaces/api/get-notifications";
import { normalizeSocialPostNotificationData } from "../utils/socialPostNotificationNormalize";
import {
  GetSystemNotificationsResponse,
  SystemNotificationsPayload,
} from "../interfaces/api/get-system-notifications";
import {
  PutReadNotificationPayload,
  PutReadNotificationResponse,
} from "../interfaces/api/put-read-notification";

export const notificationMapper = {
  mapResponseToId(
    response: PutReadNotificationResponse
  ): PutReadNotificationPayload {
    const id = response?.payload?.id;
    return { id };
  },
  mapResponseToNotifications(
    response: GetNotificationsResponse
  ): NotificationsPayload {
    const { notifications, count } = response?.payload ?? {};
    const list = notifications ?? [];
    const normalized: Notification[] = list.map((n) => {
      if (
        n.type === NotificationType.SOCIAL_POST &&
        n.data &&
        typeof n.data === "object" &&
        !Array.isArray(n.data)
      ) {
        return {
          ...n,
          data: normalizeSocialPostNotificationData(
            n.data as unknown as Record<string, unknown>
          ),
        };
      }
      return n;
    });
    return { notifications: normalized, count: count ?? 0 };
  },
  mapResponseToSystemNotifications(
    response: GetSystemNotificationsResponse
  ): SystemNotificationsPayload {
    const { infoMessage, infoMessageEn, infoMessageEs, infoMessagePt } =
      response?.payload;
    return { infoMessage, infoMessageEn, infoMessageEs, infoMessagePt };
  },
};
